(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setStickyTriggerHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.setStickyTriggerHeightHandler = this.setStickyTriggerHeight.bind(this);
      window.addEventListener('resize', this.setStickyTriggerHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setStickyTriggerHeight() {
      /* Udløsningspunktet for sticky-menuen er hero'ens eyebrow (den lille overskrift over H1), hvis den findes,
         ellers knap-rækken (.hero-cta-wrapper). Findes ingen af dem (fx artikel-/blogsider), bruges 65% af
         første sektions højde som fallback.
         Selektoren dækker klassenavnene .hero-overheading (index-hero-video.liquid), .hs-overheading (index-hero-slider.liquid), .hero-meta og
         .mom-diary-tagline (mom diary-sektionerne). */
      const heroEyebrow = document.querySelector(
        '#MainContent .hero-overheading, #MainContent .hs-overheading, #MainContent .hero-meta, #MainContent .mom-diary-tagline'
      );
      const heroCta = document.querySelector('#MainContent .hero-cta-wrapper, #MainContent .hs-cta-wrapper');
      const triggerEl = heroEyebrow || heroCta;
      if (triggerEl) {
        const triggerRect = triggerEl.getBoundingClientRect();
        /* Menuen skifter til hvid, så snart eyebrow'en rammer menuens underkant (ikke først når den er helt oppe i
           toppen af skærmen). Derfor trækkes menuens højde fra. Menuens egen højde bruges, så det passer, uanset om
           den er i stor eller kompakt størrelse. */
        const headerEl = document.querySelector('.section-header .header-wrapper');
        const headerOffset = headerEl ? headerEl.getBoundingClientRect().height : 0;
        this.stickyTriggerHeight = Math.max(
          0,
          triggerRect.top + (window.pageYOffset || document.documentElement.scrollTop) - headerOffset
        );
        this.stickyTriggerIsAbsolute = true;
        return;
      }

      const main = document.querySelector('#MainContent');
      const firstSection = main && main.children[0];
      this.stickyTriggerHeight = firstSection
        ? firstSection.getBoundingClientRect().height
        : window.innerHeight;
      this.stickyTriggerIsAbsolute = false;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setStickyTriggerHeightHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      /* Enten et absolut scroll-punkt (eyebrow'ens eller knap-rækkens position, se setStickyTriggerHeight())
         eller 65% af hero-højden, hvis ingen af dem findes. */
      const stickyTriggerPoint = this.stickyTriggerIsAbsolute
        ? this.stickyTriggerHeight
        : (this.stickyTriggerHeight || window.innerHeight) * 0.65;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* Menuen følger annoncebjælken 1:1 imens den ruller væk, styret direkte af scroll-positionen
         (--header-glide-offset) uden CSS-transition. Når bjælken er helt rullet ud af syne, låses menuen
         i sin mindre størrelse (".header-compact" i assets/base.css). */
      /* --header-top-offset = annoncebjælken + evt. kampagnebjælken (sat øverst i denne fil). Uden kampagnebjælke
         er den lig med --announcement-bar-height, så menuen opfører sig som før. */
      const rootStyle = getComputedStyle(document.documentElement);
      const announcementBarHeight = parseFloat(rootStyle.getPropertyValue('--header-top-offset')) ||
        parseFloat(rootStyle.getPropertyValue('--announcement-bar-height')) || 0;
      const glideOffset = Math.max(0, announcementBarHeight - scrollTop);
      document.documentElement.style.setProperty('--header-glide-offset', glideOffset + 'px');

      const hasClearedAnnouncementBar = scrollTop >= announcementBarHeight;
      this.header.classList.toggle('header-compact', hasClearedAnnouncementBar);
      document.body.classList.toggle('tt-announcement-hidden', hasClearedAnnouncementBar);

      if (scrollTop > this.currentScrollTop && scrollTop > stickyTriggerPoint) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > stickyTriggerPoint) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= stickyTriggerPoint) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
